/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnUserGender } from './en-user-gender';
 /**
 *
 *
 * @export
 * @interface UpdateProfileDto
 */
export interface UpdateProfileDto {

    /**
     * @type {string}
     * @memberof UpdateProfileDto
     */
    firstName?: string;

    /**
     * @type {string}
     * @memberof UpdateProfileDto
     */
    lastName?: string;

    /**
     * @type {string}
     * @memberof UpdateProfileDto
     */
    dateOfBirth?: string | null;

    /**
     * @type {number}
     * @memberof UpdateProfileDto
     */
    height?: number | null;

    /**
     * @type {number}
     * @memberof UpdateProfileDto
     */
    weight?: number | null;

    /**
     * @type {EnUserGender}
     * @memberof UpdateProfileDto
     */
    gender?: EnUserGender | null;
}
